import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchTimesheetApprovalsRequest, fetchTimesheetEmployeeDetailsRequest, resetTimesheetEmployeeApprovals, updateTimesheetApprovalRequest } from "store/actions";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";

import Swal from "sweetalert2";
import './TimesheetAccordion.css';
import Loader from "common/pageLoader";
import useButtonAccess from "components/Common/useButtonAccess";
import { useLocation, useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const TimeSheetApproval = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);

  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    departments,
    designations,
    dropdownAutoList,
    approvals,
    timesheetEmployeeApprovals,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
    approvals: state.TimesheetTransactionApprovalReducer?.approvals,
    timesheetEmployeeApprovals: state.TimesheetTransactionApprovalReducer?.timesheetEmployeeApprovals,

    loading: state.TimesheetTransactionApprovalReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.TimesheetTransactionApprovalReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
    success: state.TimesheetTransactionApprovalReducer?.success
  }));

   useEffect(() => {
        if (authDetails) {
          getAttendanceSalaryDate(authDetails.unit_id).then(response => {
            if (response.status === "success" && response.data.length > 0) {
              const data = response.data[0];
              formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
              formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
            }
          });
        }
      }, [authDetails]);
  

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      const formData = new FormData();
      formData.append("from_date", formik.values?.fromDate);
      formData.append("to_date", formik.values?.toDate);
      formData.append("emp_id", modalData?.emp_id);
      formData.append("create_by", authDetails?.user_id);
      dispatch(fetchTimesheetEmployeeDetailsRequest(formData));
    }
  }, [authDetails, success, dispatch]);

  const [timesheetApprovalData, setTimesheetApprovalData] = useState();
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    if (timesheetEmployeeApprovals && timesheetEmployeeApprovals.length > 0) {
      const initializedData = (timesheetEmployeeApprovals || []).map(row => ({
        ...row,
        selectedOption: null,
        remarks: "",
        approved_hours: row.worked_hours,
      }));
      setTimesheetApprovalData(initializedData)
    } else {
      setTimesheetApprovalData([]);
      setModal(false)
      const formData = new FormData();
      formData.append(
        "category_id",
        formik.values.category && formik.values.category.length ? formik.values.category.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "department_id",
        formik.values.department && formik.values.department.length ? formik.values.department.map(item => item.value).join(",") : '0'
      );
      formData.append("from_date", formik.values.fromDate);
      formData.append("to_date", formik.values.toDate);
      formData.append("emp_code", formik.values.employee?.label?.split(" - ")[0] || "");
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchTimesheetApprovalsRequest(formData));
    }
  }, [timesheetEmployeeApprovals])

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      fromDate: "",
      toDate: "",
      employee: "",
    },
    validationSchema: Yup.object({
      fromDate: Yup.date().nullable()
        .required("From Date is required"),

      toDate: Yup.date().nullable()
        .required("To Date is required")
        .test(
          "is-before-fromDate",
          "To Date cannot be before From Date",
          function (value) {
            const { fromDate } = this.parent;
            return !fromDate || !value || new Date(value) >= new Date(fromDate);
          }
        )
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append(
        "category_id",
        values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "department_id",
        values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0'
      );
      // formData.append(
      //   "design_id",
      //   values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0'
      // );
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("emp_code", values.employee?.label?.split(" - ")[0] || "");


      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchTimesheetApprovalsRequest(formData));
    },
  });

  useEffect(() => {
    if (!formik.values.fromDate || !formik.values.toDate) {
      dispatch(resetTimesheetEmployeeApprovals());
      setOpenId(null)
    }
  }, [formik.values.fromDate, formik.values.toDate, dispatch]);

  // const handleOptionChange = (rowId, action) => {
  //   // Update the selected option for the specific row
  //   const updatedData = timesheetApprovalData.map((row) => {
  //     if (row.timesheet_id === rowId) {
  //       return { ...row, selectedOption: action };
  //     }
  //     return row;
  //   });

  //   setTimesheetApprovalData(updatedData);
  // };

  const handleOptionChange = (rowId, action) => {
    // Update the selected option for the specific row
    const updatedData = timesheetApprovalData.map((row) => {
      if (row.timesheet_id === rowId) {
        return {
          ...row,
          selectedOption: row.selectedOption === action ? null : action
        };
      }
      return row;
    });

    setTimesheetApprovalData(updatedData);
  };

  // const handleBulkActionChange = (action) => {
  //   const updatedData = timesheetApprovalData.map((row) => ({
  //     ...row,
  //     selectedOption: action,
  //   }));
  //   setTimesheetApprovalData(updatedData);
  // };

  const handleBulkActionChange = (action) => {
    const allSelected = timesheetApprovalData.every(
      row => row.selectedOption === action
    );

    const updatedData = timesheetApprovalData.map((row) => ({
      ...row,
      selectedOption: allSelected ? null : action,
    }));
    setTimesheetApprovalData(updatedData);
  };

  const handleRemarksChange = (sno, value) => {
    const updatedData = (timesheetApprovalData || []).map((item) =>
      item.timesheet_id === sno ? { ...item, remarks: value } : item
    );
    setTimesheetApprovalData(updatedData);
  };

  const formatTimeWithColon = (val) => {
    const digits = val.replace(/\D/g, "").slice(0, 4);
    if (digits.length <= 2) return digits;
    return `${digits.slice(0, 2)}:${digits.slice(2)}`;
  };

  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const handleHourChange = (value, rowIndex) => {
    let input = value.trim();

    // Handle input without colon
    if (!input.includes(":")) {
      const digitsOnly = input.replace(/\D/g, "");
      if (digitsOnly.length === 1) {
        input = `0${digitsOnly}:00`; // "3" → "03:00"
      } else if (digitsOnly.length === 2) {
        input = `${digitsOnly}:00`; // "12" → "12:00"
      }
    }

    const formatted = formatTimeWithColon(input); // Force to HH:MM
    const updated = [...timesheetApprovalData];

    const approvedMinutes = timeToMinutes(formatted);
    const workedMinutes = timeToMinutes(updated[rowIndex]?.worked_hours || "00:00");

    if (approvedMinutes > workedMinutes) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Entry',
        text: 'Approved hours cannot be greater than worked hours.',
      });
      updated[rowIndex].approved_hours = updated[rowIndex].worked_hours;
    } else {
      updated[rowIndex].approved_hours = formatted;
    }

    setTimesheetApprovalData(updated); // Ensure update reflects globally
  };

  const columns_approved = [
    { Header: "S.No", Cell: ({ row }) => timesheetApprovalData.length - row.index, className: "serial-no", applyHeaderClass: true, },
    {
      id: "approve",
      Header: () => (
        <div className="text-center">
          Approve <br />
          <Input type="checkbox" onChange={() => handleBulkActionChange("Approve")} />
        </div>
      ),
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center">
          <Input
            type="checkbox"
            checked={row.original.selectedOption === "Approve"}
            onChange={() => handleOptionChange(row.original.timesheet_id, "Approve")}
          />
        </div>
      ),
    },
    {
      id: "reject",
      Header: () => (
        <div className="text-center">
          Reject <br />
          <Input type="checkbox" onChange={() => handleBulkActionChange("Reject")} />
        </div>
      ),
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center">
          <Input
            type="checkbox"
            checked={row.original.selectedOption === "Reject"}
            onChange={() => handleOptionChange(row.original.timesheet_id, "Reject")}
          />
        </div>
      ),
    },
    {
      id: "discussion",
      Header: () => (
        <div className="text-center">
          Discussion <br />
          <Input type="checkbox" onChange={() => handleBulkActionChange("Discussion")} />
        </div>
      ),
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center">
          <Input
            type="checkbox"
            checked={row.original.selectedOption === "Discussion"}
            onChange={() => handleOptionChange(row.original.timesheet_id, "Discussion")}
          />
        </div>
      ),
    },
    {
      Header: "Remarks",
      Cell: ({ row }) => {
        const rowIndex = row.index;
        const [value, setValue] = useState(timesheetApprovalData[rowIndex]?.remarks || "");

        const handleBlur = () => {
          if (value) {
            handleRemarksChange(row.original.timesheet_id, value);
          }
        };

        return (
          <Input
            type="text"
            bsSize="sm"
            placeholder="Enter remarks"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={handleBlur} // only update global state on focus out
          />
        );
      }
    },   
    {
      Header: "AH",
      accessor: "approved_hours",
      Cell: ({ row }) => {
        const rowIndex = row.index;
        const [value, setValue] = useState(timesheetApprovalData[rowIndex]?.approved_hours || "");
        return (
          <Input
            type="text"
            value={value}
            onChange={(e) => setValue(formatTimeWithColon(e.target.value))}
            onBlur={(e) => {
              const formatted = formatTimeWithColon(e.target.value);
              setValue(formatted); // update local state
              handleHourChange(formatted, rowIndex); // validate and save to global state
            }}
            placeholder="HH:MM"
            style={{ width: "80px", padding: "4px" }}
          />
        );
      },
    },
    { Header: "FH", accessor: "final_hours" },
    { Header: "WH", accessor: "worked_hours" },    
    { Header: "Project", accessor: "project_name" },
    { Header: "Date", accessor: "t_date" },
    { Header: "Task", accessor: "task_name" },
    { Header: "Type", accessor: "task_type" },
    {
      Header: "Description",
      accessor: "task_description",
      Cell: ({ value }) => (
        <div style={{
          whiteSpace: "normal",
          wordBreak: "break-word",
          width: "500px",
          overflowWrap: "anywhere",
          lineHeight: "1.4"
        }}>
          {value}
        </div>
      )
    },
     { Header: "Status", accessor: "task_status" }    
    
    // {
    //   id: "approve",
    //   Header: () => (
    //     <div className="text-center">
    //       Approve <br />
    //       <Input
    //         type="checkbox"
    //       //  name="selectAll"
    //         onChange={() => handleBulkActionChange("Approve")}
    //       />
    //     </div>
    //   ),
    //   Cell: ({ row }) => (
    //     <div
    //       className="d-flex justify-content-center align-items-center"
    //       onClick={() => handleOptionChange(row.original.timesheet_id, "Approve")}
    //       style={{ cursor: "pointer" }}
    //     >
    //       {row.original.selectedOption === "Approve" ? (
    //         <FaCheck color="green" size={20} />
    //       ) : (
    //         <Input
    //           type="checkbox"
    //          // name={`action-${row.original.timesheet_id}`}
    //          // onChange={() => handleOptionChange(row.original.timesheet_id, "Approve")}
    //           checked={row.original.selectedOption === "Approve"}
    //         />
    //       )}
    //     </div>
    //   ),
    // },
    // {
    //   id: "reject",
    //   Header: () => (
    //     <div className="text-center">
    //       Reject <br />
    //       <Input
    //         type="checkbox"
    //         //name="selectAll"
    //         onChange={() => handleBulkActionChange("Reject")}
    //       />
    //     </div>
    //   ),
    //   Cell: ({ row }) => (
    //     <div
    //       className="d-flex justify-content-center align-items-center"
    //       onClick={() => handleOptionChange(row.original.timesheet_id, "Reject")}
    //       style={{ cursor: "pointer" }}
    //     >
    //       {row.original.selectedOption === "Reject" ? (
    //         <FaCheck color="red" size={20} />
    //       ) : (
    //         <Input
    //           type="checkbox"
    //           // name={`action-${row.original.timesheet_id}`}
    //           // onChange={() => handleOptionChange(row.original.timesheet_id, "Reject")}
    //           checked={row.original.selectedOption === "Reject"}
    //         />
    //       )}
    //     </div>
    //   ),
    // },
    // {
    //    id: "discussion",
    //    Header: () => (
    //     <div className="text-center">
    //       Discussion <br />
    //       <Input
    //         type="checkbox"
    //         // name="selectAll"
    //         onChange={() => handleBulkActionChange("Discussion")}
    //       />
    //     </div>
    //   ),
    //   Cell: ({ row }) => (
    //     <div
    //       className="d-flex justify-content-center align-items-center"
    //       onClick={() => handleOptionChange(row.original.timesheet_id, "Discussion")}
    //       style={{ cursor: "pointer" }}
    //     >
    //       {row.original.selectedOption === "Discussion" ? (
    //         <FaCheck color="orange" size={20} />
    //       ) : (
    //         <Input
    //           type="checkbox"
    //           // name={`action-${row.original.timesheet_id}`}
    //           // onChange={() => handleOptionChange(row.original.timesheet_id, "Discussion")}
    //           checked={row.original.selectedOption === "Discussion"}
    //         />
    //       )}
    //     </div>
    //   ),
    // },
  ];

  const handleView = async (rowData) => {
    const empIdStr = String(rowData?.emp_id);
    const isOpen = openId === empIdStr;
    if (!formik.values.fromDate || !formik.values.toDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From and To dates before proceeding.",
      });
      return;
    }
    setOpenId(isOpen ? null : empIdStr);
    // Only fetch if not already loaded and not collapsing
    if (!isOpen) {
      const formData = new FormData();
      formData.append("from_date", formik.values?.fromDate);
      formData.append("to_date", formik.values?.toDate);
      formData.append("emp_id", rowData?.emp_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchTimesheetEmployeeDetailsRequest(formData));
      setModalData(rowData);
    }
  };

  const handleLateApprove = () => {
    const approvalStatusMap = {
      Approve: "1",
      Reject: "2",
      Discussion: "3"
    };

    const updatedClaims = (timesheetApprovalData || [])
      .filter(item => item.selectedOption)
      .map(item => ({
        timesheet_id: item.timesheet_id.toString(),
        approval_status: approvalStatusMap[item.selectedOption] || "0",
        approval_hours: item.approved_hours || "0",
        approval_remarks: item.remarks || ""
      }));

    if (updatedClaims.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one before proceeding.",
      });
      return;
    }

    const payload = { timesheet: updatedClaims };
    const convertObject = JSON.stringify(payload);
    const formData = new FormData();
    formData.append("lst_timesheet_transaction_approval", convertObject);
    // formData.append("unit_id", authDetails?.unit_id);
    formData.append("create_by", authDetails?.user_id);
    dispatch(updateTimesheetApprovalRequest(formData))
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Time Sheet" breadcrumbItem="Approval" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col md={4} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="category">Category</Label>
                    <CustomSelect
                      id="category"
                      name="category"
                      options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                      value={formik.values.category || null}
                      onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                      isMulti
                    />
                    {formik.touched.category && formik.errors.category && (
                      <div className="text-danger">{formik.errors.category}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="department">Department</Label>
                    <CustomSelect
                      id="department"
                      name="department"
                      options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                      value={formik.values.department || null}
                      onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                      isMulti
                    />
                    {formik.touched.department && formik.errors.department && (
                      <div className="text-danger">{formik.errors.department}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="employee">Employee</Label>
                    <CustomSelect
                      id="employee"
                      name="employee"
                      options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                      value={formik.values.employee || null}
                      onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                    />
                    {formik.touched.employee && formik.errors.employee && (
                      <div className="text-danger">{formik.errors.employee}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="fromDate">From Date <span className="text-danger">*</span></Label>
                    <CustomDatePicker
                      name="fromDate"
                      value={formik.values.fromDate}
                      onChange={(date) => formik.setFieldValue("fromDate", date)}
                      onBlur={formik.handleBlur}
                      disableFuture={true}
                    />
                    {formik.touched.fromDate && formik.errors.fromDate && (
                      <div className="text-danger">{formik.errors.fromDate}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="toDate">To Date <span className="text-danger">*</span></Label>
                    <CustomDatePicker
                      name="toDate"
                      value={formik.values.toDate}
                      onChange={(date) => formik.setFieldValue("toDate", date)}
                      onBlur={formik.handleBlur}
                      disableFuture={true}
                    />
                    {formik.touched.toDate && formik.errors.toDate && (
                      <div className="text-danger">{formik.errors.toDate}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4} sm={12} className="d-flex align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2"><i className="fas fa-search me-1" /> Search</Button>
                  <Button type="button" onClick={formik.handleReset} className="btn button-cancel"><i className="fas fa-sync me-1" /> Cancel</Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        {approvals && approvals.length > 0 && (
          <Card>
            <CardBody>
              {openId && canApprove && (
                <div className="d-flex justify-content-end mb-3">
                  <Button type="button" className="btn button-save" onClick={handleLateApprove}>
                    <i className="fas fa-save me-1" /> Update
                  </Button>
                </div>
              )}
              <Accordion open={openId} toggle={() => {}} className="w-100">
                {approvals.map((emp) => (
                  <AccordionItem className="border-0 box-shadow mb-2" key={emp.emp_id}>
                    <AccordionHeader
                      targetId={String(emp.emp_id)}
                      className={`accordion-header ${openId === String(emp.emp_id) ? 'accordion-open' : ''}`}
                      onClick={() => handleView(emp)}
                    >
                      <div
                        className="timesheet-summary timeaccsheet"
                        style={{ display: "grid", gridTemplateColumns: "2fr 1fr", alignItems: "center", width: "100%" }}
                      >
                        <div>
                          <p className="employee-name mb-0">{emp.emp_name} - {emp.emp_no}</p>
                          <small className="employee-department">{emp.department || "No Department"}</small>
                        </div>
                        <div style={{ textAlign: "right", paddingRight: "10px" }}>
                          <strong>Worked Hours:</strong> <span>{emp.timesheet_hours || "00:00"} Hrs</span>
                        </div>
                      </div>
                    </AccordionHeader>
                    <AccordionBody accordionId={String(emp.emp_id)}>
                      <div className="timesheet-table">
                        <TableContainer
                          columns={columns_approved}
                          data={timesheetApprovalData && timesheetApprovalData.length > 0 ? timesheetApprovalData : []}
                          isGlobalFilter={true}
                          customPageSize={10}
                        />
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  );
};

export default TimeSheetApproval;
